<template>
    <div id="calligraphy">
        <div class="banner">
            <div class="go_back"
                 @click="goBack"></div>
        </div>
        <div class="content">
            <ul class="advantage">
                <li class="ad_item"
                    v-for="(ad,ind) in ad_list"
                    :key="ind">
                    <div class="item_left">
                        <img class="item_icon"
                             :style="ad.style"
                             :src="ad.icon">
                        <div class="item_label">{{ ad.name }}</div>
                    </div>
                    <div class="item_right">{{ ad.content }}</div>
                </li>
            </ul>
        </div>
        <div class="bottom_btn">
            <a class="btn"
               href="javascript:;"
               @click="downloadImg">下载练习字帖</a><a class="btn open"
               href="javascript:;"
               @click="goOpen">开通爱尚书法</a>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data () {
        return {
            ad_list: [
                {
                    icon: require("./img/img_icon_01.png"),
                    name: "同步练习",
                    content: "课程围绕书法，学习运笔和基本笔画，让学生掌握汉字造型规律。",
                    style: {
                        width: "1.5rem",
                        height: "1.275rem"
                    }
                },
                {
                    icon: require("./img/img_icon_02.png"),
                    name: "规范教程",
                    content: "从偏旁部首，间架结构等方面科学系统的教授学生书写技巧，规范书写习惯。 ",
                    style: {
                        width: "1.4rem",
                        height: "1.45rem"
                    }
                },
                {
                    icon: require("./img/img_icon_03.png"),
                    name: "中圆格书法",
                    content: "对传统“田”“米”字格的改良，降低孩子的书写难度。",
                    style: {
                        width: "1.425rem",
                        height: "1.425rem"
                    }
                }
            ],
            openStatus: false
        }
    },
    created () {
        this.$http.post(API_URL_BASE_API + '/account/open/status', { subject_id: 11 }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                if (res.data.length && res.data[0].status && res.data[0].status !== 1 && res.data[0].status !== 4) {
                    this.openStatus = true;
                }
            }
        })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", "1");
        },
        downloadImg (url) {
            this.appFunction('ys_openbrowser', "https://fileres.m.tbkt.cn/yw_newwords/2022/04/25/20220425152738455723.jpg")
        },
        goOpen () {
            if (this.openStatus) {
                layer.tips("您已开通书法课程，无法再次开通。")
            } else {
                this.openPop(11);
            }
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#calligraphy {
    min-height: 100vh;
    background-color: #eaedf8;
    padding-bottom: 140px / $ppr;
    box-sizing: border-box;
    .banner {
        background-image: url("./img/banner.jpg");
        width: 100%;
        height: 600px / $ppr;
        background-size: 100% 100%;
        position: relative;
        .go_back {
            position: absolute;
            width: 56px / $ppr;
            height: 56px / $ppr;
            background-size: 100% 100%;
            background-image: url("./img/img_icon_04.png");
            cursor: pointer;
            top: 30px / $ppr;
            left: 40px / $ppr;
        }
    }
    .content {
        padding: 0 40px / $ppr;
        .advantage {
            margin-top: -129px / $ppr;
            border-radius: 8px / $ppr;
            overflow: hidden;
            background-color: #fff;
            position: relative;
            z-index: 2;
            .ad_item {
                height: 180px / $ppr;
                box-sizing: border-box;
                display: flex;
                font-size: 26px / $ppr;
                &:nth-of-type(2) {
                    .item_left {
                        background-color: #38bd9a;
                    }
                    .item_right {
                        background-color: #ebf8f5;
                    }
                }
                .item_left {
                    width: 154px / $ppr;
                    flex-shrink: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    display: flex;
                    background-color: #4bcba9;
                    .item_icon {
                        display: block;
                        margin-top: 4px / $ppr;
                    }
                    .item_label {
                        line-height: 1;
                        padding-top: 19px / $ppr;
                    }
                }
                .item_right {
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 40px / $ppr;
                    color: #464d6a;
                    line-height: 48px / $ppr;
                }
            }
        }
    }
    .bottom_btn {
        position: fixed;
        width: 100%;
        height: 100px / $ppr;
        background-color: #fff;
        text-align: center;
        padding-top: 20px / $ppr;
        left: 0;
        bottom: 0;
        .btn {
            width: 320px / $ppr;
            display: inline-block;
            height: 80px / $ppr;
            border-radius: 40px / $ppr;
            line-height: 80px / $ppr;
            font-size: 30px / $ppr;
            color: #4bcba9;
            text-align: center;
            background-color: #ebf8f5;
            margin-right: 20px / $ppr;
            &.open {
                color: #fff;
                margin-right: 0;
                background-color: #4bcba9;
            }
        }
    }
}
</style>